import React from "react";
import "./Divisions.scss";
const Divisions = () => {
  return (
    <div>
      <h3>Divisions</h3>
      <p>
        A company division is a semi-autonomous unit within a larger organization, structured around a
        specific product, service, geographic market, or customer group, with its own management,
        resources, and performance goals. Divisions operate like smaller companies within the main
        one, enabling focused strategies, quicker decision-making, and better responsiveness to market
        changes, while still adhering to the overall corporate objectives. The main feature of its
        development is dynamic growth, prosperity and stability. Since 2007 company is specializing in
        the field of Instrument, Control, Automation, Fire &amp; Security, and Electrical, Mechanical
        installation and maintenance.
      </p>
      <p>Petroen Engineering DMCC has the following divisions:</p>
      <ol>
        <li>Specialized Technical services division</li>
        <ul>
          <li>Project management and technical assistance.</li>
          <li>Mechanical Completion Verification</li>
          <li>Operation and Maintenance services.</li>
          <li>Pre-Commissioning &amp; Commissioning</li>
          <li>Supply of Skilled and Un Skilled Manpower</li>
        </ul>
        <li>EPCC (Engineering, Procurement, Construction & Commissioning)</li>
        <li>Supply Chain Division</li>
        <li>Industrial Engineering Solutions</li>
        <li>Training & Networking</li>
        <li>Manufacturing</li>
        <li>Engineering</li>
        <li>Software</li>
      </ol>
    </div>
  );
};
export default Divisions;
